export default __webpack_public_path__ + "assets/ico_block_connected-a35d6653.svg";